import React from 'react';
import { FileTextIcon } from 'lucide-react';
import { Section } from './Section';
const POINTS = ['El libro principal y los 5 bonos son PDF', 'Puedes leerlo desde tu iPhone, iPad o computadora', 'Lo recibes por mail apenas confirmas la compra'];
export function Format() {
  return <Section className="bg-ink-950" data-id="element-175" data-mp="3e0a4q43m0zwk">
      <div className="grid gap-8 lg:grid-cols-[0.9fr_1.1fr] lg:items-center" data-id="element-176" data-mp="3dz8n1gs39f5v">
        <div data-id="element-177" data-mp="308c2md8bg49w">
          <p className="mb-3 text-xs font-semibold uppercase tracking-[0.22em] text-accent-soft" data-id="element-178" data-mp="307u57d9x3k0e">
            Formato
          </p>
          <h2 className="text-3xl font-extrabold leading-[1.15] tracking-tight text-white sm:text-4xl" data-id="element-179" data-mp="350wrr1ga1t73">
            Todo el contenido es en PDF
          </h2>
          <p className="mt-5 text-base leading-relaxed text-white/65" data-id="element-180" data-mp="2v8zgjup9r18d">
            Documentos claros que puedes leer, buscar o imprimir cuando
            quieras. Sin plataformas complicadas, sin videos largos y sin
            esperar nada: lo abres y lo aplicas.
          </p>
        </div>

        <ul className="space-y-3" data-id="element-181" data-mp="2c7l53g7qrq4q">
          {POINTS.map(point => <li key={point} className="flex items-center gap-4 rounded-3xl border border-white/8 bg-ink-950/70 p-5 text-sm text-white/75 sm:text-base" data-id="element-182" data-mp="2ca7b3bezhxku">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-accent/15" data-id="element-183" data-mp="2m5isy2lovkwt">
                <FileTextIcon className="h-5 w-5 text-accent-soft" aria-hidden="true" data-id="element-184" data-mp="2h8sbpby5ej9t" />
              </span>
              {point}
            </li>)}
        </ul>
      </div>
    </Section>;
}